import {
  GET_ALL_STORE_ORDERS,
  NEXT_CUSTOMER_INITIALIZE,
  SET_CURRENT_CASHIER,
  SET_CURRENT_CASHIER_CREDITS,
  SET_CURRENT_CASHIER_DATA,
  SET_CURRENT_CUSTOMER,
  SET_CUSTOMER_REDEEMABLE_REWARDS,
  SET_POINTS_ON_FIRST_ORDER,
  SET_REDEEMED_DATA,
  SET_STORE_REWARDS,
  SET_CASHIER_PARENT,
  SET_CASHIER_STORE_DETAILS,
} from "../types";

const initialState = {
  creds: {},
  cashier: {},
  order_id: "",
  order_value: "",
  orderHistory: {},
  storeDetails: {},
  cashierParent: {},
  earned_points: "",
  redemptionData: {},
  currentCustomer: {},
  storeAllRewards: {},
  isAuthenticated: false,
  customerRedeemableRewards: [],
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_CASHIER:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case SET_CASHIER_STORE_DETAILS:
      return {
        ...state,
        storeDetails: action.payload,
      };
    case SET_CASHIER_PARENT:
      return {
        ...state,
        cashierParent: action.payload,
      };
    case SET_CURRENT_CASHIER_DATA:
      return {
        ...state,
        cashier: action.payload,
      };
    case SET_CURRENT_CUSTOMER:
      return {
        ...state,
        currentCustomer: action.payload,
      };
    case SET_STORE_REWARDS:
      return {
        ...state,
        storeAllRewards: action.payload,
      };
    case SET_CUSTOMER_REDEEMABLE_REWARDS:
      return {
        ...state,
        customerRedeemableRewards: action.payload,
      };
    case SET_POINTS_ON_FIRST_ORDER:
      return {
        ...state,
        order_id: action.payload?.id,
        order_value: action.payload?.value,
        earned_points: action.payload?.points_earned,
      };
    case SET_REDEEMED_DATA:
      return {
        ...state,
        redemptionData: action.payload,
      };
    case SET_CURRENT_CASHIER_CREDITS:
      return {
        ...state,
        creds: action.payload,
      };
    case NEXT_CUSTOMER_INITIALIZE:
      return {
        ...state,
        order_id: "",
        order_value: "",
        earned_points: "",
        redemptionData: {},
      };
    case GET_ALL_STORE_ORDERS:
      return {
        ...state,
        orderHistory: action.payload,
      };
    default:
      return state;
  }
};

export default user;
